import * as Common from '@/tenant/common';

export class TransferBalance extends Common.ObjectBase{
  constructor(){
    super('TransferBalance')
    this.binders.debitJournals = new Common.ModelBinder(Common.TransferJournal);
    this.binders.creditJournals = new Common.ModelBinder(Common.TransferJournal);
  }
  public id: number = 0;
  public debitCredit: number = 0;
  public currencyCode: string = '';
  public isBooked: boolean = false;
  public openDate: Date = new Date().getCalendarDate();
  public closeDate: Date = new Date().getCalendarDate();
  public initialBookDate: Date = new Date().getCalendarDate();
  public initialBookRate: number = 0;
  public initialBookAmountFC: number = 0;
  public initialBookAmount: number = 0;
  public ratePrecision: number = 0;
  public rateRoundType: number = 0;
  public description: string = '';
  public debitJournals: Common.TransferJournal[] = new Array();
  public creditJournals: Common.TransferJournal[] = new Array();
}

export enum DebitCreditFlags {
  Debit,
  Credit
}